import { formatCurrency, formatDate, formatPercentages } from 'helpers/formatData';

export const primaryRows = (transaction) => {
  return {
    id: transaction?.transactionId ?? 'NA',
    transactionDate: transaction?.transactionDate ? formatDate(transaction?.transactionDate) : 'NA',
    northCapTradeId: transaction?.northCapTradeId ?? 'NA',
    propertyName: transaction?.propertyName ?? 'NA',
    propertyType: transaction?.propertyType ?? 'NA',
    userName: transaction?.userName ?? 'NA',
    transactionType: transaction?.transactionType ?? 'NA',
    noOfShares: transaction?.qty ?? 0,
    pricePerShare: formatCurrency(transaction?.pricePerShare ?? 0),
    totalInvestmentAmount: formatCurrency(transaction?.investmentAmount ?? 0),
    platformFees: transaction?.platformFees ?? 0,
    equity: formatPercentages(transaction?.equity ?? 0),
    fundedStatus: formatPercentages(transaction?.fundedStatus ?? 0),
  };
};

export const secondaryRows = (transaction) => {
  return {
    id: transaction?.transactionId ?? 'NA',
    transactionDate: transaction?.transactionDate ? formatDate(transaction?.transactionDate) : 'NA',
    northCapAskOrderId: transaction?.northCapAskOrderId ?? 'NA',
    northCapBidOrderId: transaction?.northCapBidOrderId ?? 'NA',
    propertyName: transaction?.propertyName ?? 'NA',
    propertyType: transaction?.propertyType ?? 'NA',
    buyerName: transaction?.buyerName ?? 'NA',
    sellerName: transaction?.sellerName ?? 'NA',
    executedSharePrice: formatCurrency(transaction?.executedSharePrice ?? 0),
    totalInvestmentAmount: formatCurrency(transaction?.investmentAmount ?? 0),
    equity: formatPercentages(transaction?.equity ?? 0),
  };
};

export const openRows = (transaction) => {
  return {
    id: transaction?.orderId ?? 'NA',
    transactionDate: transaction?.transactionDate ? formatDate(transaction?.transactionDate) : 'NA',
    northCapTradeId: transaction?.northCapTradeId ?? 'NA',
    northCapOrderId: transaction?.northCapOrderId ?? 'NA',
    propertyName: transaction?.propertyName ?? 'NA',
    propertyType: transaction?.propertyType ?? 'NA',
    userName: transaction?.userName ?? 'NA',
    type: transaction?.transactionType ?? 'NA',
    noOfShares: transaction?.qty ?? 0,
    duration: transaction?.orderDuration ?? 'NA',
    pricePerShare: formatCurrency(transaction?.pricePerShare ?? 0),
    totalInvestmentAmount: formatCurrency(transaction?.investmentAmount ?? 0),
  };
};

export const cancelledRows = (transaction) => {
  return {
    id: transaction?.orderId ?? 'NA',
    transactionDate: transaction?.transactionDate ? formatDate(transaction?.transactionDate) : 'NA',
    northCapTradeId: transaction?.northCapTradeId ?? 'NA',
    northCapOrderId: transaction?.northCapOrderId ?? 'NA',
    propertyName: transaction?.propertyName ?? 'NA',
    propertyType: transaction?.propertyType ?? 'NA',
    userName: transaction?.userName ?? 'NA',
    type: transaction?.transactionType ?? 'NA',
    noOfShares: transaction?.qty ?? 0,
    cancelledBy: transaction?.cancelledBy ?? 'NA',
    pricePerShare: formatCurrency(transaction?.pricePerShare ?? 0),
    totalInvestmentAmount: formatCurrency(transaction?.investmentAmount ?? 0),
  };
};
